import * as types from "../../constants/index"
export default {
  state: {
    hasPublished: false
  },
  mutations: {
    [types.OPERATE_STREAM](state, payload) {
      state.hasPublished = payload
    }
  },
  getters: {
    hasPublished: state => state.hasPublished
  }
}
